exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer{width:100%;margin-top:20vw;padding-bottom:50px;position:relative;background-color:#015351}.footer .content{width:100%;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;-ms-flex-direction:column;flex-direction:column}.footer .content .logo{width:100px;height:100px}.footer .backgroundColor{fill:#015351}.footer .rotated{position:absolute;top:calc(-24vw / 2 - 2vw);left:0;width:100%;z-index:-1}.footer .social{margin:20px}.footer button{border-radius:20px;margin:20px;background-color:white;font-weight:bold}.footer ul{list-style:none;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:0;margin:25px 20px 5px 20px}.footer ul li{display:inline;margin:5px 10px;color:rgba(255,255,255,0.9)}.footer em{color:white}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/Footer/Footer.scss
// module id = 315
// module chunks = 0